import React from "react";
import groovyWalkAnimation from "../../assets/loader.json";
import Lottie from "lottie-react";

const LottieLoader = () => {
  return <Lottie animationData={groovyWalkAnimation} loop={true} />;
};

export default LottieLoader;
